import { insertTrackEvent, eCommerceTrackEvent } from './common.js';

export const trackGameInfoOpen = ({ game, category }) =>
	insertTrackEvent({
		category,
		action: 'Game info card open',
		label: `${game?.name} - ${game?.code}`
	});

export const trackGameInfoClosed = ({ game, category }) =>
	insertTrackEvent({
		category,
		action: 'Game info card close',
		label: `${game?.name} - ${game?.code}`
	});

export const trackGameInfoPlayClick = ({ game, mode, category }) =>
	insertTrackEvent({
		category,
		action: 'Game info card CTA click',
		label: `${game?.name} - ${game?.code} - ${mode}`
	});

export const trackGameClick = ({
	game,
	mode,
	listName,
	position,
	isLiveCasinoLocation,
	category = '',
	seat,
	isTableFull
}) =>
	eCommerceTrackEvent({
		event: 'EECproductClick',
		eComObj: {
			currencyCode: 'EUR',
			click: {
				actionField: {
					list: `${isLiveCasinoLocation ? 'LiveCasino' : 'Casino'} ${listName}${seat ? ' - seat' : ''}${isTableFull ? ' - full table' : ''}`
				},
				products: [
					{
						name: game.name,
						id: game.gameId,
						category,
						variant: mode,
						position: position >= 0 ? position + 1 : undefined
					}
				]
			}
		}
	});
